export default __webpack_public_path__ + "/dist/images/recipe-banner-img.jpg";